import { useEffect } from 'react'
import { useForm } from 'react-hook-form'

const SharedLinkForm = ({
  getLinks,
  link,
  objectSettings,
  uuid,
  setVisibleForm,
  setVisibleCreateForm,
  scope_type,
  scope_id
}) => {
  let defaultValues = link
    ? { ...link }
    : {
        user_can_health: objectSettings.user_can_health,
        user_timesheet_values: objectSettings.user_timesheet_values,
        user_tracked_times: objectSettings.user_tracked_times,
        locale: I18n.locale
      }
  if (defaultValues.settings) {
    defaultValues.settings.expenses =
      defaultValues.settings.expenses == 'true' || defaultValues.settings.expenses == true
    defaultValues.settings.timesheet_values =
      defaultValues.settings.timesheet_values == 'true' || defaultValues.settings.timesheet_values == true
    defaultValues.settings.tracked_times =
      defaultValues.settings.tracked_times == 'true' || defaultValues.settings.tracked_times == true
    defaultValues.settings.hide_detail_info =
      defaultValues.settings.hide_detail_info == 'true' || defaultValues.settings.hide_detail_info == true
    defaultValues.settings.basic_comments =
      defaultValues.settings.basic_comments == 'true' || defaultValues.settings.basic_comments == true
    defaultValues.settings.basic_changes =
      defaultValues.settings.basic_changes == 'true' || defaultValues.settings.basic_changes == true
    defaultValues.settings.basic_associations =
      defaultValues.settings.basic_associations == 'true' || defaultValues.settings.basic_associations == true
    defaultValues.settings.basic_comment_email =
      defaultValues.settings.basic_comment_email == 'true' || defaultValues.settings.basic_comment_email == true
    defaultValues.settings.timesheet_time_entry_prices =
      defaultValues.settings.timesheet_time_entry_prices == 'true' ||
      defaultValues.settings.timesheet_time_entry_prices == true
  }

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    setValue
  } = useForm({ reValidateMode: 'onSubmit', defaultValues: defaultValues })
  const watchedTabs = watch('tabs')
  const watchedSettings = watch('settings')
  const watchedBasicComments = watch('settings.basic_comments')

  useEffect(() => {
    jQuery('#tabs-' + uuid)
      .select2({
        allowClear: true
      })
      .on('change', (e) => {
        setValue('tabs', $(e.target).val())
      })
  }, [])

  const createLink = (formData) => {
    jQuery.ajax({
      url: window.appData.api_path + '/shared_links',
      method: 'POST',
      data: {
        shared_link: formData,
        scope_type: scope_type,
        scope_id: scope_id
      },
      success: () => {
        reset()
        getLinks()
        setVisibleCreateForm(false)
      }
    })
  }

  const updateLink = (formData) => {
    jQuery.ajax({
      url: window.appData.api_path + '/shared_links/' + link.id,
      method: 'PATCH',
      data: {
        shared_link: formData,
        scope_type: scope_type,
        scope_id: scope_id
      },
      success: () => {
        getLinks()
        setVisibleForm(false)
      }
    })
  }

  const selectAllTabs = (e) => {
    e.preventDefault()
    let names = objectSettings.tabs.map((tab) => tab.codename)
    jQuery('#tabs-' + uuid)
      .val(names)
      .trigger('change')
  }

  return (
    <form onSubmit={handleSubmit(link ? updateLink : createLink)} className="react-form mb-16">
      <div className="row">
        <div className="col-md-6">
          <div className={`form-group ${errors.name ? 'has-error' : ''}`}>
            <label htmlFor={`name-${uuid}`}>{I18n.t('activerecord.attributes.shared_link.name')}</label>
            <input
              name="name"
              id={`name-${uuid}`}
              {...register('name', { required: true, maxLength: { value: 50 } })}
              type="text"
              className="input form-control"
              autoFocus={true}
              autoComplete="off"
            />
            {errors.name?.type === 'required' && (
              <span className="help-block">{I18n.t('simple_form.required.text')}</span>
            )}
            {errors.name?.type === 'maxLength' && (
              <span className="help-block">{I18n.t('sidebar-link-name-maxlength', { lng: 50 })}</span>
            )}
          </div>
        </div>

        <div className="col-md-6">
          <div className={`form-group ${errors.locale ? 'has-error' : ''}`}>
            <label htmlFor={`locale-${uuid}`}>{I18n.t('locale')}</label>
            <div className="select-wrapper">
              <select
                name="locale"
                id={`locale-${uuid}`}
                {...register('locale', { required: true })}
                className="form-control"
              >
                {window.appData.locales.map((locale) => (
                  <option key={locale.id} value={locale.id}>
                    {locale.name}
                  </option>
                ))}
              </select>
              {errors.locale?.type === 'required' && (
                <span className="help-block">{I18n.t('simple_form.required.text')}</span>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className={`form-group ${errors.tabs ? 'has-error' : ''}`}>
        <label htmlFor={`tabs-${uuid}`}>{I18n.t('activerecord.attributes.shared_link.tabs')}</label>
        <div className="select-wrapper">
          <select id={`tabs-${uuid}`} {...register('tabs', { required: true })} className="form-control" multiple>
            {objectSettings.tabs.map((tab, i) => (
              <option value={tab.codename} key={i}>
                {tab.name}
              </option>
            ))}
          </select>
          {errors.tabs?.type === 'required' && (
            <span className="help-block">{I18n.t('simple_form.required.text')}</span>
          )}
        </div>
        <a href="#" className="small-link no-top" onClick={selectAllTabs}>
          {I18n.t('select-all').toLowerCase()}
        </a>
      </div>

      <div className="mb-16">
        <span className="checkbox">
          <label htmlFor={`settings_hide_detail_info_${uuid}`}>
            <input
              name="settings.hide_detail_info"
              id={`settings_hide_detail_info_${uuid}`}
              {...register('settings.hide_detail_info')}
              type="checkbox"
              className="check_boxes optional"
            />
            {I18n.t('shared-link-settings.hide-detail-info')}
          </label>
        </span>
      </div>

      {['task', 'project'].includes(scope_type) && !watchedSettings?.hide_detail_info ? (
        <div className="mb-16">
          <span className="checkbox">
            <label htmlFor={`settings_timesheet_time_entry_prices_${uuid}`}>
              <input
                id={`settings_timesheet_time_entry_prices_${uuid}`}
                {...register('settings.timesheet_time_entry_prices')}
                type="checkbox"
                className="check_boxes optional"
              />
              {I18n.t('shared-link-settings.timesheet-time-entry-prices')}
            </label>
          </span>
        </div>
      ) : null}

      {['task', 'project'].includes(scope_type) ? (
        <div className="mb-16">
          <span className="checkbox">
            <label htmlFor={`settings_expenses_${uuid}`}>
              <input
                name="settings.expenses"
                id={`settings_expenses_${uuid}`}
                {...register('settings.expenses')}
                type="checkbox"
                disabled={!defaultValues.user_can_health}
                className="check_boxes optional"
              />
              {I18n.t('shared-link-settings.expenses')}
            </label>
          </span>
        </div>
      ) : null}

      {['task', 'project'].includes(scope_type) &&
      watchedTabs &&
      (watchedTabs.includes('timesheets') ||
        watchedTabs.includes('time_entries') ||
        watchedTabs.includes('budget_items')) ? (
        <div className="mb-16">
          <span className="checkbox">
            <label htmlFor={`settings_timesheet_values_${uuid}`}>
              <input
                name="settings.timesheet_values"
                id={`settings_timesheet_values_${uuid}`}
                {...register('settings.timesheet_values')}
                type="checkbox"
                disabled={!defaultValues.user_timesheet_values}
                className="check_boxes optional"
              />
              {I18n.t('shared-link-settings.timesheet-values')}
            </label>
          </span>
        </div>
      ) : null}

      {['task', 'project'].includes(scope_type) && watchedTabs && watchedTabs.includes('time_entries') ? (
        <div className="mb-16">
          <span className="checkbox">
            <label htmlFor={`settings_tracked_times_${uuid}`}>
              <input
                name="settings.tracked_times"
                id={`settings_tracked_times_${uuid}`}
                {...register('settings.tracked_times')}
                type="checkbox"
                disabled={!defaultValues.user_tracked_times}
                className="check_boxes optional"
              />
              {I18n.t('tracked_times')}
            </label>
          </span>
        </div>
      ) : null}

      {watchedTabs && watchedTabs.includes('basic') ? (
        <>
          <h5>{I18n.t('basic-tab')}</h5>

          <div className="basic-tab-filter-checkboxes mb-16">
            <div className="form-group boolean">
              <span className="checkbox">
                <label htmlFor={`settings_basic_comments_${uuid}`}>
                  <input
                    name="settings.basic_comments"
                    id={`settings_basic_comments_${uuid}`}
                    {...register('settings.basic_comments')}
                    type="checkbox"
                    className="check_boxes optional"
                  />
                  {I18n.t('shared-link-settings.basic-comments')}
                </label>
              </span>
            </div>

            <div className="form-group boolean">
              <span className="checkbox">
                <label htmlFor={`settings_basic_changes_${uuid}`}>
                  <input
                    name="settings.basic_changes"
                    id={`settings_basic_changes_${uuid}`}
                    {...register('settings.basic_changes')}
                    type="checkbox"
                    className="check_boxes optional"
                  />
                  {I18n.t('shared-link-settings.basic-changes')}
                </label>
              </span>
            </div>

            <div className="form-group boolean">
              <span className="checkbox">
                <label htmlFor={`settings_basic_associations_${uuid}`}>
                  <input
                    name="settings.basic_associations"
                    id={`settings_basic_associations_${uuid}`}
                    {...register('settings.basic_associations')}
                    type="checkbox"
                    className="check_boxes optional"
                  />
                  {I18n.t('shared-link-settings.basic-associations')}
                </label>
              </span>
            </div>

            {watchedBasicComments && ['task', 'project'].includes(scope_type) ? (
              <div className="form-group boolean">
                <span className="checkbox">
                  <label htmlFor={`settings_basic_comment_email_${uuid}`}>
                    <input
                      name="settings.basic_comment_email"
                      id={`settings_basic_comment_email_${uuid}`}
                      {...register('settings.basic_comment_email')}
                      type="checkbox"
                      className="check_boxes optional"
                    />
                    {I18n.t('shared-link-settings.basic-comment-email')}
                  </label>
                </span>
              </div>
            ) : null}
          </div>
        </>
      ) : null}

      <button type="submit" className="btn btn-primary btn-lg align-top">
        {I18n.t('save')}
      </button>
    </form>
  )
}

export default SharedLinkForm
